(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list-new/assets/javascripts/column-components/game-buy-stop.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list-new/assets/javascripts/column-components/game-buy-stop.js');

'use strict';

const _excluded = ["buyStop", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const GameBuyStop = _ref => {
  let buyStop = _ref.buyStop,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutProperties(_ref, _excluded);
  const baseClassName = 'game-buy-stop';
  const combinedClassName = "".concat(baseClassName, " ").concat(className).trim();

  const formatBuyStop = buyStopDate => {
    if (!buyStopDate) {
      return 'Ej angivet';
    }
    try {
      const date = new Date(buyStopDate);
      return formatDate(date, true, true, true);
    } catch (error) {
      return buyStopDate;
    }
  };
  return React.createElement("div", _extends({
    className: combinedClassName
  }, props), React.createElement("span", {
    className: "game-buy-stop-label"
  }, "K\xF6p senast:", ' ', formatBuyStop(buyStop)));
};
setGlobal('svs.components.marketplace.gameListNew.columnComponents.GameBuyStop', GameBuyStop);

 })(window);